import React, { useEffect } from 'react';
import { reloadAddwish } from './addwishAPI';
import { withRouter } from 'react-router';
const AddwishProvider = ({ children, history }) => {
    // Listen to route changes
    useEffect(() => {
        const unregister = history.listen(() => {
            reloadAddwish();
        });
        return unregister;
    }, [history]);
    return React.createElement(React.Fragment, null, children);
};
export default withRouter(AddwishProvider);
//# sourceMappingURL=AddwishProvider.js.map